// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reduce-padding{padding-top:30px !important}`, "",{"version":3,"sources":["webpack://./Resources/assets/app/components/adverts/advertFeaturePage/advertFeaturePage.scss"],"names":[],"mappings":"AAGA,gBACI,2BAAA","sourcesContent":[".advertFeaturePage {\n\n}\n.reduce-padding {\n    padding-top: 30px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
